import React from 'react';
import { Box, Link } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';

const SONIC_LOGO_URL = 'https://sonops.sonicnet.net.au/assets/sonic-logo-white.png';

/**
 * Full-width header for the order page. Sonic branding: #1e2330 background, white text.
 * Shared bar styling is used by OrderTallyComponent so header and footer match.
 */
export const ORDER_BAR_BG = '#0d1f3c';
export const ORDER_BAR_GRADIENT = 'linear-gradient(160deg, #0d1f3c 0%, #152a4a 55%, #1a3358 100%)';
export const ORDER_BAR_TEXT = '#fff';
export const ORDER_BAR_TEXT_MUTED = 'rgba(255, 255, 255, 0.85)';

export const ORDER_BAR_STYLES = {
  background: ORDER_BAR_GRADIENT,
  color: ORDER_BAR_TEXT,
  borderColor: 'rgba(255, 255, 255, 0.12)',
  borderWidth: '1px',
  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  py: 1.5,
  px: 2,
};

const linkSx = {
  color: ORDER_BAR_TEXT,
  fontSize: '0.9375rem',
  '&:hover': { color: 'rgba(255, 255, 255, 0.9)' },
};

function OrderPageHeader() {
  return (
    <Box
      component="header"
      sx={{
        ...ORDER_BAR_STYLES,
        borderBottom: `${ORDER_BAR_STYLES.borderWidth} solid ${ORDER_BAR_STYLES.borderColor}`,
        borderTop: 'none',
        position: 'sticky',
        top: 0,
        zIndex: 1100,
      }}
    >
      <Box
        maxWidth="lg"
        mx="auto"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={2}
      >
        <Link
          href="https://sonicnet.net.au/"
          target="_blank"
          rel="noopener noreferrer"
          underline="none"
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <img
            src={SONIC_LOGO_URL}
            alt="Sonic Internet & Voice"
            style={{ height: 36, display: 'block' }}
          />
        </Link>
        <Box component="nav" display="flex" alignItems="center" gap={3}>
          <Link
            href="https://sonicnet.net.au/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={linkSx}
          >
            Home
          </Link>
          <Link
            href="https://status.sonicnet.net.au/"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={linkSx}
          >
            Status
          </Link>
          <Link
            href="tel:13003737333"
            underline="hover"
            sx={{
              ...linkSx,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75,
              fontWeight: 600,
            }}
          >
            <PhoneIcon sx={{ fontSize: '1.1rem' }} />
            1300 37 37 33
          </Link>
        </Box>
      </Box>
    </Box>
  );
}

export default OrderPageHeader;
